import { trackAnalytics } from "services/analytics";

export const faHeaderNavClick = ({ flowName, segment, lob, product }) => {
  const headerValue = "header";
  flowName = flowName?.replace("&", "and").toLowerCase();
  segment = segment?.replace("&", "and").toLowerCase();
  lob = lob?.replace("&", "and").toLowerCase();
  product = product?.replace("&", "and").toLowerCase();
  trackAnalytics({
    eVar9: `b2b${flowName ? "|" + flowName : ""}${segment ? "|" + segment : ""}${lob ? "|" + lob : ""}${
      product ? "|" + product : ""
    }`,
    prop6: headerValue,
    prop7: segment,
    prop8: lob,
    prop9: product,
    prop0: `b2b${flowName ? "|" + flowName : ""}`,
  });
};
